import React from "react";

export const ViewContext = React.createContext(
    { frameLess:false, frameLessRequested:false, setFrameLess:()=>{} , setFrameLessRequested:()=>{} }
);